import { Instagram, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { SITE } from "@/constants/site";

export default function Footer() {
    const { t } = useLanguage();
    const year = new Date().getFullYear();
    return (
        <footer className="relative bg-ink text-cream pt-20 pb-10" data-testid="footer">
            <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
                    {/* Brand */}
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-4 mb-6">
                            <img
                                src={SITE.logo}
                                alt="Frizerka"
                                className="w-14 h-14 rounded-full ring-1 ring-gold/50"
                            />
                            <div>
                                <div className="font-display italic text-2xl text-white">Frizerka</div>
                                <div className="text-[0.65rem] tracking-[0.35em] uppercase text-gold mt-1">
                                    Hair by Tijana
                                </div>
                            </div>
                        </div>
                        <p className="text-white/60 max-w-sm leading-relaxed">
                            {t.footer.tag}
                        </p>
                        <div className="mt-5 inline-flex items-center gap-2 text-white/80">
                            <span className="inline-flex items-center justify-center w-4 h-4 rounded-full border border-gold/60">
                                <span className="w-1 h-1 rounded-full bg-gold" />
                            </span>
                            <span className="text-[0.62rem] tracking-[0.35em] uppercase">
                                Offizieller Keune Partner
                            </span>
                        </div>
                    </div>

                    {/* Contact */}
                    <div className="md:col-span-3">
                        <div className="eyebrow !text-gold mb-5">{t.footer.contact}</div>
                        <ul className="space-y-2 text-white/80">
                            <li>{SITE.address.street}</li>
                            <li>{SITE.address.city}</li>
                            <li>
                                <a href={`tel:${SITE.phoneRaw}`} className="hover:text-gold transition-colors">
                                    {SITE.phone}
                                </a>
                            </li>
                            <li>
                                <a href={`mailto:${SITE.email}`} className="hover:text-gold transition-colors">
                                    {SITE.email}
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Hours */}
                    <div className="md:col-span-2">
                        <div className="eyebrow !text-gold mb-5">{t.footer.hours}</div>
                        <ul className="space-y-2 text-white/80 text-sm">
                            <li>Mo · 09–15</li>
                            <li className="text-white/40">Di · —</li>
                            <li>Mi · 09–15</li>
                            <li>Do · 09–15</li>
                            <li>Fr · 09–15</li>
                            <li>Sa · 09–15</li>
                            <li className="text-white/40">So · —</li>
                        </ul>
                    </div>

                    {/* Follow */}
                    <div className="md:col-span-2">
                        <div className="eyebrow !text-gold mb-5">{t.footer.follow}</div>
                        <div className="flex flex-col gap-3">
                            <a
                                href={SITE.instagram}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 text-white/80 hover:text-gold transition-colors"
                                data-testid="footer-instagram"
                            >
                                <Instagram className="w-4 h-4" /> Instagram
                            </a>
                            <a
                                href={SITE.whatsapp}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-3 text-white/80 hover:text-gold transition-colors"
                                data-testid="footer-whatsapp"
                            >
                                <MessageCircle className="w-4 h-4" /> WhatsApp
                            </a>
                        </div>
                    </div>
                </div>

                {/* Big brand mark */}
                <div className="py-14 flex items-center justify-center overflow-hidden">
                    <div className="font-display italic text-[18vw] leading-none text-white/[0.06] select-none">
                        Frizerka
                    </div>
                </div>

                <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/50">
                    <div>© {year} Frizerka – Hair by Tijana. {t.footer.rights}</div>
                    <div className="flex items-center gap-6">
                        <Link to="/impressum" className="hover:text-gold transition-colors tracking-[0.2em] uppercase" data-testid="footer-impressum">
                            Impressum
                        </Link>
                        <Link to="/datenschutz" className="hover:text-gold transition-colors tracking-[0.2em] uppercase" data-testid="footer-datenschutz">
                            Datenschutz
                        </Link>
                    </div>
                    <div className="tracking-[0.3em] uppercase">Mannheim · Deutschland</div>
                </div>
            </div>
        </footer>
    );
}
